import Navbar from './components/navbar';
import './App.css';
import "./output-tailwind.css"
function App() {
  return (
    <div className="App">
        <Navbar />
      </div>
  );
}
export default App;
